// Track left, right, and middle mouse click on given container $element
App.namespace.wrap('es6.shared.track_click', ($element, callback, { linkSelector } = { linkSelector: 'a' }) => {
  const KEY_MAP = {
    2: 'middle',
    3: 'right',
  };

  $($element).on('click', linkSelector, e => callback(e, 'left'));
  $($element).on('mousedown', linkSelector, (e) => {
    if (e.which === 2 || e.which === 3) {
      callback(e, KEY_MAP[e.which]);
    }
  });
});
